import React from 'react';
import { isFirefox, isSafari } from 'react-device-detect';
import { IconCalendar } from '../icons';
import { jsx as ___EmotionJSX } from "@emotion/react";
var dateTypes = ['date', 'datetime-local', 'month', 'week'];
var unsupportedFirefoxSafariTypes = ['month', 'week'];

/**
 * This is needed if input type is date, datetime-local, month, or week to change default icon to IconCalendar
 */
export function getTrailingIcon(type, icon) {
  var isDateType = dateTypes.includes(type);
  var isUnsupportedDateType = (isSafari || isFirefox) && unsupportedFirefoxSafariTypes.includes(type);
  return isDateType && !isUnsupportedDateType ? ___EmotionJSX(IconCalendar, null) : icon;
}